export const accountSettings = {
  BasicInfo: "Basic info",
  Security: "Security",
  Preferences: "Preferences",
  PaymentInfo: "Payment info",
  InfoAboutYou:
    "Info about you that will appear in your Fullscript account and to your {{patientTermPlural}}.",
  ClerkBasicInfo:
    "Info about you that will appear in your Fullscript account and to your {{patientTermPlural}} as well as your account's security preferences",
  PublicInformation: "Public information",
  EditPublicInformation: "Edit public information",
  EmailTo: "Email to:",
  AddNpiNumber: "Add NPI number",
  Npi: "NPI",
  PublicPhoneNumber: "Public phone number",
  PublicEmailAddress: "Public email address",
  ManageCommunications:
    "Manage where and how you receive communications from Fullscript and your {{patientTermPlural}}.",
  GetNotifiedPatientAccount:
    "Get notified when a {{patientTerm}} creates an account on your dispensary.",
  GetNotifiedOrderPlaced: "Get notified when an order is placed on your dispensary.",
  GetNotifiedShipmentSent: "Get notified when a shipment has been sent to a {{patientTerm}}.",
  GetNotifiedOutOfStock:
    "Get notified when a product in one of your {{patientTerm}} plans becomes unavailable.",
  GetNotifiedLabResultsReceived: "Get notified when a lab result has been received.",
  NotificationsEmail: "Notifications email",
  EditNotificationsEmail: "Edit notifications email",
  NotificationsSettings: "Notifications settings",
  PatientsProductRequests: "Patient product requests",
  EditPatientsProductRequests: "Edit patient requests",
  SelectStaffMember: "Select staff member",
  ProductRequestsSentToEmail:
    "This staff member will receive patient requests and will be able to create a plan with those products.",
  ProductRequestNotificationsDescription:
    "You'll always be notified when {{ patientTermPlural }} request access to a restricted product. Select the individual who receives these notifications.",
  ProductRequestsSuccess: "Product requests staff member updated successfully",
  ProductRequestsError: "An error occurred while trying to update product requests staff member",
  AvailabilityAlerts: "Product availability alerts",
  GetNotified:
    "Get notified when products in your plans become discontinued, back-ordered, or out of stock, preventing {{patientTermPlural}} from purchasing them.",
  GetNotifiedAndConfigureNotifications:
    "Get notified daily or weekly when products in your plans become unavailable. Select the individual who receives these notifications.",
  Off: "Off",
  Daily: "Daily",
  Weekly: "Weekly (Default)",
  Notifications: "Notifications",
  NotificationsSentToEmail: "Notifications will be sent to this email address.",
  UpdateEmailAndPassword: "Update your account's email and password here.",
  LoginInformation: "Login information",
  PasswordPlaceholder: "**************",
  EditName: "Edit name",
  AddNpi: "Add NPI",
  EditLicenseInformation: "Edit license information",
  EditLicenseInformationDescription:
    "Your NPI and license information determines which lab tests you can recommend without using an authorization network.",
  Title: "Title",
  FirstName: "First name",
  LastName: "Last name",
  Suffix: "Suffix",
  UpdateNameSuccess: "Name updated sucessfully",
  FormValidation: {
    Required: "This field is required.",
    Email: {
      Invalid: "Please enter a valid email",
    },
    Phone: {
      Invalid: "Please enter a valid phone number",
    },
  },
  FormSuccess: {
    PublicProfile: "Public profile updated successfully",
    LicenseInfo: "License info updated successfully",
    UpdatedLicenseInformationSuccessfully: "License information updated successfully",
    UpdatedClinicAddressSuccessfully: "Clinic address updated successfully",
    CreditCardDelete: "Credit card removed successfully",
    EmailUpdated: "Email updated successfully",
    NotificationsSettings:
      "Notifications settings updated successfully. Refresh the page to see the changes",
    LabAlerts: "Lab notification settings updated successfully",
    NotificationsSettingsUpdated: "Notifications settings updated successfully",
    InAppTerminology: "In-app terminology updated successfully",
    ProductAvailabilityAlerts: "Product availability alerts updated successfully",
  },
  FormError: {
    CreditCardDelete: "An error occurred while trying to remove your card. Please try again.",
    InvalidEmail: "Email is invalid.",
    InvalidPhoneNumber: "Phone number is invalid.",
    NotificationsSettings:
      "An error occurred while trying to update notifications settings. Please try again.",
    InAppTerminology:
      "An error occurred while trying to update in-app terminology. Please try again.",
    LabAlerts:
      "An error occurred while trying to update lab notification settings. Please try again.",
    ProductAvailabilityAlerts:
      "An error occurred while trying to update product availability alerts. Please try again.",
  },
  CreditCards: "Credit cards",
  NoCreditCards:
    "Credit cards used for wholesale orders will appear here after you place an order and choose to save it for later.",
  ManagePaymentMethods: "Manage your payment methods on file for wholesale orders on Fullscript.",
  RemoveCreditCardHeading: "Remove credit card?",
  RemoveCreditCard: "Remove credit card",
  ConfirmDeleteCreditCard: "Are you sure you want to remove this card from your account?",
  EditEmail: "Edit email",
  NewEmail: "New email",
  SaveEmail: "Save email",
  Save: "Save",
  Accounts: "Accounts",
  ConnectedAccounts: "Connected accounts",
  Connections: "Connections",
  ConnectedAccountsDescription: "Manage external accounts that are connected with Fullscript.",
  Disconnect: "Disconnect",
  DisconnectionSuccess: "Successfully disconnected",
  NoConnectedAccounts: "You have no external accounts connected with Fullscript.",
  ConfirmDisconnection: "Confirm disconnection",
  ConfirmDisconnectionBody: "Are you sure you want to disconnect this account from Fullscript?",
  DisconnectButtonAriaLabel: "Button disconnects external integration, {{name}}",
  VisitCertificationsPage: "Visit certifications page",
  ViewCredentials: "View credentials",
  UploadNew: "Upload new",
  Upload: "Upload",
  DropzoneText: "Drag and drop credentials",
  WhyDoWeRequire: "Why do we require professional credentials?",
  CertificationBlurb: {
    Fullscript:
      "Since Fullscript is a service that connects health practitioners with their {{patientTermPlural}}, it is important we keep up-to-date credentials on file to maintain the professional integrity of the platform. Your credentials also gives you access to the professional-grade supplement brands available on Fullscript.",
    Emerson:
      "Your credentials give you access to the professional-grade supplement brands available on Emerson Ecologics. It's important we keep up-to-date-credentials on file to maintain the professional integrity of the platform.",
  },
  UploadCredentials: "Upload credentials",
  UploadSuccessful: "Credentials uploaded successfully!",
  ProfessionalCredentials: "Professional credentials",
  SaveName: "Save name",
  SavePublicInfo: "Save public information",
  SaveNpiNumber: "Save NPI number",
  SaveLicenseInformation: "Save license information",
  onsiteProducts: {
    title: "On-site products",
    description:
      "Enable the ability to flag products in your individual plans as 'filled on-site'.",
    link: "Learn more",
  },
} as const;
